module.exports = __webpack_public_path__ + "img/used-car-in.343194fc.jpg";